module.exports = __webpack_public_path__ + "img/footer_wave.8227c4af.png";